export const en = {
  app_name: 'CueTitan',
  login: {
    title: 'Staff Login',
    pin_label: 'Enter PIN',
    submit: 'Login',
    locked: 'Too many attempts. Try again in {{seconds}}s.',
    wrong_pin: 'Incorrect PIN',
    must_change: 'You must change your PIN before continuing.',
    change_pin: 'Change PIN',
    new_pin: 'New PIN (4-6 digits)',
    confirm_pin: 'Confirm PIN',
    pins_no_match: 'PINs do not match',
    pin_too_short: 'PIN must be 4-6 digits',
    pin_changed: 'PIN changed successfully',
  },
  game: {
    frame: 'Frame',
    of: 'of',
    score: 'Score',
    break: 'Break',
    reds: 'Reds',
    frames: 'Frames',
    active_player: 'Active',
    switch_player: 'Switch Player',
    concede_frame: 'Concede Frame',
    undo: 'Undo',
    next_frame: 'Next Frame',
    end_game: 'End Game',
    reset_frame: 'Reset Frame',
    foul: 'Foul',
    free_ball: 'Free Ball',
    miss: 'Miss',
    confirm_concede: 'Concede this frame?',
    confirm_reset: 'Reset current frame? Scores will be lost.',
    confirm_end: 'End the game? All progress will be saved.',
    start_game: 'Start Game',
    player_1: 'Player 1',
    player_2: 'Player 2',
    frames_target: 'Frames Target',
    open_ended: 'Open-ended',
    press_to_start: 'Press any key to start',
    resume_game: 'Resume Game',
    menu: 'Menu',
    time: 'Time',
    left: 'Left',
    vs: 'VS',
    breaking: 'Breaking',
    half_century: 'Half Century',
    century: 'Century',
    frame_complete: 'Frame Complete',
    next_frame_hint: 'Press {{key}} for next frame',
    pot_red: 'Pot a red',
    pot_color: 'Pot a color',
    colors_next: 'Colors — {{ball}} next',
    colors_complete: 'Colors — complete',
    no_active_game: 'No active game',
    up_next: 'Up next',
    no_players_waiting: 'No players waiting',
    games: 'Games',
    best_break: 'Best break',
    foul_hint: 'Select the ball that was touched (min 4 pts)',
    hint_red: 'Red',
    hint_color: 'Color',
    hint_undo: 'Undo',
    hint_switch: 'Switch',
    hint_next: 'Next',
    hint_reset: 'Reset',
    hint_end: 'End',
    hint_queue: 'Queue',
  },
  waiting: {
    title: 'Waiting List',
    add_player: 'Add Player',
    name_placeholder: 'Full name...',
    add: 'Add',
    remove: 'Remove',
    start_match: 'Start Match',
    qr_title: 'Self-Registration QR',
    qr_hint: 'Players can scan to join the list',
    empty: 'No players waiting',
    position: '#{{pos}}',
    clear_all: 'Clear All',
    move_up: 'Move up',
    move_down: 'Move down',
  },
  stats: {
    title: 'Statistics',
    total_games: 'Total Games',
    total_revenue: 'Total Revenue',
    top_players: 'Top Players',
    date_from: 'From',
    date_to: 'To',
    player_search: 'Player Name',
    export_pdf: 'Export PDF',
    export_excel: 'Export Excel',
    staff_filter: 'Staff',
    type_filter: 'Type',
    all: 'All',
    clear: 'Clear',
    no_games: 'No games found.',
    columns: {
      date: 'Date',
      player1: 'Player 1',
      player2: 'Player 2',
      winner: 'Winner',
      frames: 'Frames',
      amount: 'Amount',
      staff: 'Staff',
    },
  },
  tables: {
    floor: 'Floor',
    in_use: 'In Use',
    free: 'Free',
    waiting: 'Waiting',
    available: 'Available',
    reserved: 'Reserved',
    maintenance: 'Maintenance',
    live: 'Live',
    tap_to_start: 'Tap a table to start or resume a game',
    snooker: 'Snooker',
    eight_ball: '8-Ball',
    add_table: 'Add Table',
    session_history: 'Session history',
    no_history: 'No completed games on this table yet.',
    type: 'Type',
  },
  settings: {
    title: 'Settings',
    club_name: 'Club Name',
    logo: 'Club Logo',
    upload_logo: 'Upload Logo',
    price_per_frame: 'Price per Frame',
    currency: 'Currency',
    undo_limit: 'Undo Limit',
    retention_days: 'Stats Retention (days)',
    keep_forever: 'Keep Forever',
    server_enabled: 'Local Server',
    server_port: 'Server Port',
    local_ip: 'Local IP',
    qr_code: 'Server QR Code',
    reset_pin: 'Reset PIN',
    purge_data: 'Purge Old Data',
    purge_confirm: 'This will delete all game data older than your retention period. Continue?',
    language: 'Language',
    save: 'Save',
    saved: 'Settings saved',
    logo_change: 'Change logo',
    logo_upload: 'Upload logo',
    logo_remove: 'Remove logo',
    logo_hint: 'PNG, JPG, WebP or SVG · max {{kb}}KB',
    logo_too_large: 'Image too large (max {{kb}}KB)',
    logo_not_image: 'Please choose an image file',
    logo_read_error: 'Could not read file',
    section_club: 'Club',
    section_pricing: 'Pricing',
    section_gameplay: 'Gameplay',
    section_retention: 'Data Retention',
    section_server: 'Local Server',
    default_p1: 'Default Player 1 Name',
    default_p2: 'Default Player 2 Name',
    audio_enabled: 'Sound Effects',
    color_assist: 'Color Vision Assist',
    section_accessibility: 'Accessibility & Audio',
    work_start_time: 'Work Start Time',
    work_end_time: 'Work End Time',
  },
  staff: {
    title: 'Staff Management',
    add_staff: 'Add Staff',
    add_manager: 'Add Manager',
    name: 'Name',
    role: 'Role',
    pin: 'PIN',
    deactivate: 'Deactivate',
    reset_pin: 'Reset PIN',
    no_staff: 'No staff members yet',
    active_staff: 'Active Staff',
    change_my_pin: 'Change My PIN',
    new_pin: 'New PIN',
    confirm_pin: 'Confirm PIN',
    pin_updated: 'PIN updated successfully.',
    tables_btn: 'Tables',
    assigned_tables: 'Assigned Tables',
    no_tables: 'No tables configured yet.',
    no_restriction: 'all tables visible (no restriction)',
    pin_reset_pending: 'PIN reset pending',
    temp_pin_for: 'Temporary PIN for',
    temp_pin_hint: 'They will be asked to change it on next login.',
  },
  nav: {
    home: 'Home',
    game: 'Game',
    waiting: 'Waiting List',
    stats: 'Stats',
    settings: 'Settings',
    staff: 'Staff',
    logout: 'Logout',
  },
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    loading: 'Loading...',
    error: 'An error occurred',
  },
  join: {
    title: 'Join Waiting List',
    subtitle: 'Enter your name to join the waiting list',
    name_placeholder: 'Your full name',
    submit: 'Join List',
    success_title: 'You\'re on the list!',
    success_message: 'You\'ve been added to the waiting list. A staff member will call you when it\'s your turn.',
    join_another: 'Join Again',
    error_empty: 'Please enter your name',
    error_failed: 'Failed to register. Please try again.',
  },
};

export type Translations = typeof en;
